import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import './Navbar.css';
import logo from 'assets/logo.jpg';
import { useNavigate, useLocation } from 'react-router-dom'; // Added useLocation

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation(); // Hook to check what route we are currently on

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleLinkClick = (targetId, pageURL) => {
        setIsOpen(false);

        // Check if we are already on the page we want to navigate to
        if (location.pathname === pageURL) {
            // We are already here! Just scroll to the element.
            if (targetId) {
                const element = document.getElementById(targetId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            } else {
                // If no targetId (like clicking Testimonials while on Testimonials), scroll to top
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } else {
            // We are on a different page. Navigate to the new URL and pass the targetId in history state!
            window.scrollTo({ top: 0, });
            navigate(pageURL, { state: { scrollToId: targetId } });
        }
    };

    return (
        <nav className="navbar">
            <div className="nav-logo"
            onClick={() => handleLinkClick('about', '/')}>
                <img src={logo} alt="Logo" style={{ height: '8vh', borderRadius: '0.5rem', margin: '0.5rem', padding: '0.5rem', backgroundColor: 'white' }} />
            </div>

            {/* Desktop Navigation */}
            <div className="nav-links-desktop">
                <button onClick={() => handleLinkClick('about', '/')}>About</button> {/* Changed 'about' to 'home' to match your section ID */}
                <button onClick={() => handleLinkClick('services', '/')}>Services</button> {/* Changed 'services' to 'testimonials' to match your section ID */}
                <button onClick={() => handleLinkClick('contact', '/')}>Contact</button>
                <button onClick={() => handleLinkClick('testimonials', '/testimonials')}>Testimonials</button>
            </div>

            {/* Hamburger Toggle Button */}
            <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle Menu">
                {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>

            {/* Full-Screen Fade Overlay */}
            <div className={`menu-overlay ${isOpen ? 'active' : ''}`}>
                <div className="overlay-links">
                    <button onClick={() => handleLinkClick('about', '/')}>About</button>
                    <button onClick={() => handleLinkClick('services', '/')}>Services</button>
                    <button onClick={() => handleLinkClick('contact', '/')}>Contact</button>
                    <button onClick={() => handleLinkClick('testimonials', '/testimonials')}>Testimonials</button>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;